const message_IT = {
    "data": [
        {
            "code": 500000,
            "message": "Errore interno del sistema"
        },
        {
            "code": 500001,
            "message": "Sponsor non trovato"
        },
        {
            "code": 500002,
            "message": "Errore di pagamento"
        },
        {
            "code": 500003,
            "message": "Errore nel cambio valuta"
        },
        {
            "code": 500004,
            "message": "Metodo di pagamento non trovato"
        },
        {
            "code": 500005,
            "message": "Gateway di pagamento non trovato"
        },
        {
            "code": 500006,
            "message": "Piano non trovato"
        },
        {
            "code": 500007,
            "message": "L'importo è nullo o zero"
        },
        {
            "code": 500008,
            "message": "L'importo è nullo o saldo insufficiente nel portafoglio"
        },
        {
            "code": 500009,
            "message": "Cliente speciale non può essere sponsor"
        },
        {
            "code": 500010,
            "message": "L'id del piano deve essere Business Partner"
        },
        {
            "code": 500011,
            "message": "Sponsor utente non trovato"
        },
        {
            "code": 500012,
            "message": "Utente non trovato"
        },
        {
            "code": 500013,
            "message": "Fallimento nel tentativo di autenticare l'utente"
        },
        {
            "code": 500014,
            "message": "Errore nella decodifica del token JWT"
        },
        {
            "code": 500015,
            "message": "Questo token JWT non appartiene all'utente della richiesta"
        },
        {
            "code": 500016,
            "message": "Nome utente non disponibile"
        },
        {
            "code": 500017,
            "message": "Esiste già un account associato a questa email"
        },
        {
            "code": 500018,
            "message": "Il campo Currency è vuoto o nullo"
        },
        {
            "code": 500019,
            "message": "Errore nel caricamento del file"
        },
        {
            "code": 500020,
            "message": "Il pagamento tramite bonifico non può essere confermato"
        },
        {
            "code": 500021,
            "message": "Cliente speciale non può trasferire ExtraCoin"
        },
        {
            "code": 500022,
            "message": "Saldo insufficiente nel portafoglio ExtraCoin"
        },
        {
            "code": 500023,
            "message": "Saldo insufficiente nel portafoglio"
        },
        {
            "code": 500024,
            "message": "Esiste già un account associato a questo numero di documento"
        },
        {
            "code": 500025,
            "message": "Questa email non corrisponde a questo utente"
        },
        {
            "code": 500026,
            "message": "Piano utente non trovato"
        },
        {
            "code": 500027,
            "message": "Voucher non valido"
        },
        {
            "code": 500028,
            "message": "Il pagamento con voucher è valido solo per la registrazione di Area Manager"
        },
        {
            "code": 500029,
            "message": "Id transazione non trovato"
        },
        {
            "code": 500030,
            "message": "Questa transazione non appartiene a questo utente"
        },
        {
            "code": 500031,
            "message": "Questa transazione non è in attesa di conferma del trasferimento"
        },
        {
            "code": 500032,
            "message": "Categoria non trovata con l'id corrispondente"
        },
        {
            "code": 500033,
            "message": "Attributo non trovato con l'id corrispondente"
        },
        {
            "code": 500034,
            "message": "L'id dell'attributo non corrisponde all'utente della richiesta"
        },
        {
            "code": 500035,
            "message": "Cliente speciale non può creare prodotti"
        },
        {
            "code": 500036,
            "message": "Sottocategoria non trovata"
        },
        {
            "code": 500037,
            "message": "Prodotto non trovato"
        },
        {
            "code": 500038,
            "message": "L'id del prodotto non appartiene all'utente della richiesta"
        },
        {
            "code": 500039,
            "message": "Il prodotto è già associato a questo attributo"
        },
        {
            "code": 500040,
            "message": "L'importo minimo per creare un coupon è 50"
        },
        {
            "code": 500042,
            "message": "Coupon non valido"
        },
        {
            "code": 500043,
            "message": "Il coupon non appartiene all'utente sponsor"
        },
        {
            "code": 500044,
            "message": "Cliente speciale non può creare coupon"
        },
        {
            "code": 500045,
            "message": "Il prodotto non è associato a questo attributo"
        },
        {
            "code": 500046,
            "message": "Il prodotto ha già variazioni registrate"
        },
        {
            "code": 500047,
            "message": "Non puoi creare una variante con gli stessi attributi"
        },
        {
            "code": 500048,
            "message": "Tutti gli attributi devono avere almeno un valore assegnato"
        },
        {
            "code": 500049,
            "message": "Il marchio non è associato alla sottocategoria"
        },
        {
            "code": 500050,
            "message": "Campo subcategory non trovato"
        },
        {
            "code": 500051,
            "message": "Marca non trovata"
        },
        {
            "code": 500052,
            "message": "Il tipo non è associato alla sottocategoria"
        },
        {
            "code": 500053,
            "message": "Tipo non trovato"
        },
        {
            "code": 500054,
            "message": "GenderProduct non è associato alla sottocategoria"
        },
        {
            "code": 500055,
            "message": "GenderProduct non trovato"
        },
        {
            "code": 500056,
            "message": "Variante prodotto non trovata"
        },
        {
            "code": 500057,
            "message": "Il prodotto può avere solo 2 attributi"
        },
        {
            "code": 500058,
            "message": "Il prodotto non ha attributi registrati"
        },
        {
            "code": 500059,
            "message": "Questo prodotto ha variazioni. Non puoi impostare l'importo totale"
        },
        {
            "code": 500060,
            "message": "Questa variante non corrisponde a questo prodotto"
        },
        {
            "code": 500061,
            "message": "Il campo Language è vuoto o nullo"
        },
        {
            "code": 500062,
            "message": "L'ordine deve avere almeno un articolo"
        },
        {
            "code": 500063,
            "message": "Stato consentito: PUBLISHED o UNPUBLISHED"
        },
        {
            "code": 500064,
            "message": "Acquirente e venditore devono essere diversi"
        },
        {
            "code": 500065,
            "message": "Ordine non trovato"
        },
        {
            "code": 500066,
            "message": "Questo ordine non appartiene a questo utente"
        },
        {
            "code": 500067,
            "message": "Il prodotto nell'articolo non appartiene al venditore dell'ordine"
        },
        {
            "code": 500068,
            "message": "Articolo non trovato nell'ordine"
        },
        {
            "code": 500069,
            "message": "Questo prodotto ha variazioni, specificare un idvariation"
        },
        {
            "code": 500070,
            "message": "La percentuale di extracoin deve essere tra il 50% e il 97% per i Business Partner"
        },
        {
            "code": 500071,
            "message": "La percentuale di extracoin deve essere tra il 10% e il 97% per gli Area Manager"
        },
        {
            "code": 500072,
            "message": "La percentuale di extracoin è superiore a quanto richiesto dal venditore"
        },
        {
            "code": 500073,
            "message": "La somma di Extracoin + Wallet + Cash deve essere uguale al totale dell'ordine"
        },
        {
            "code": 500074,
            "message": "Esaurito -> Prodotto"
        },
        {
            "code": 500075,
            "message": "Impossibile modificare/eliminare un articolo da un ordine che non è aperto"
        },
        {
            "code": 500076,
            "message": "L'importo massimo possibile di extracoin è stato superato. Rivedi il tuo ordine!"
        },
        {
            "code": 500077,
            "message": "Questo utente non è il venditore di questo ordine"
        },
        {
            "code": 500078,
            "message": "Questo ordine non può essere spedito"
        },
        {
            "code": 500079,
            "message": "Questo utente non è l'acquirente di questo ordine"
        },
        {
            "code": 500080,
            "message": "Questo ordine non può essere ricevuto"
        },
        {
            "code": 500081,
            "message": "Carriera non trovata"
        },
        {
            "code": 500082,
            "message": "Il portafoglio di origine ha saldo insufficiente per pagare la commissione"
        },
        {
            "code": 500083,
            "message": "Il portafoglio di destinazione ha saldo insufficiente per pagare la commissione"
        },
        {
            "code": 500084,
            "message": "Il portafoglio Extracoin di origine ha saldo insufficiente per il trasferimento"
        },
        {
            "code": 500085,
            "message": "Il portafoglio Extracoin di destinazione ha saldo insufficiente per il trasferimento"
        },
        {
            "code": 500086,
            "message": "ID trasferimento non trovato"
        },
        {
            "code": 500087,
            "message": "Questo utente non ha relazione con questo trasferimento"
        },
        {
            "code": 500088,
            "message": "L'utente di origine e destinazione sono gli stessi"
        },
        {
            "code": 500089,
            "message": "Il codice di conferma del trasferimento non è corretto"
        },
        {
            "code": 500090,
            "message": "L'utente di origine non ha ancora confermato la transazione"
        },
        {
            "code": 500091,
            "message": "Puoi valutare solo gli ordini che hai contrassegnato come ricevuti"
        },
        {
            "code": 500092,
            "message": "Hai già valutato questo ordine"
        },
        {
            "code": 500093,
            "message": "Le valutazioni devono essere tra 1 e 5"
        },
        {
            "code": 500094,
            "message": "La password attuale non è corretta"
        },
        {
            "code": 500095,
            "message": "La nuova password deve essere diversa dalla password attuale"
        },
        {
            "code": 500096,
            "message": "Token di conferma telefono non trovato"
        },
        {
            "code": 500097,
            "message": "Questo numero di telefono è già confermato"
        },
        {
            "code": 500098,
            "message": "Codice non valido - conferma numero di telefono"
        },
        {
            "code": 500099,
            "message": "Solo i Clienti speciali possono passare ad Area Manager"
        },
        {
            "code": 500100,
            "message": "Esiste già un pagamento associato a questo transactionid"
        },
        {
            "code": 500101,
            "message": "La transazione di pagamento non può essere confermata"
        },
        {
            "code": 500102,
            "message": "Solo i Clienti speciali possono passare a Business Partner"
        },
        {
            "code": 500103,
            "message": "Utente non attivo. Non puoi richiedere prelievi."
        },
        {
            "code": 500104,
            "message": "L'utente mittente non ha relazione con questo ordine"
        },
        {
            "code": 500105,
            "message": "L'utente destinatario non ha relazione con questo ordine"
        },
        {
            "code": 500106,
            "message": "Messaggio chat non trovato"
        },
        {
            "code": 500107,
            "message": "L'utente non è il destinatario di questo messaggio chat"
        },
        {
            "code": 500108,
            "message": "Questo utente non può vedere i messaggi di questo ordine"
        },
        {
            "code": 500109,
            "message": "Questo profilo non può indicare un Sale Promoter"
        },
        {
            "code": 500110,
            "message": "L'id del piano deve essere Sale Promoter"
        },
        {
            "code": 500111,
            "message": "Sale Promoter non può creare prodotti"
        },
        {
            "code": 500112,
            "message": "Admin non può creare prodotti"
        },
        {
            "code": 500113,
            "message": "L'utente non ha il permesso di admin (superuser)"
        },
        {
            "code": 500114,
            "message": "I campi latitude/longitude sono obbligatori"
        },
        {
            "code": 500115,
            "message": "Il campo origin of register è obbligatorio"
        },
        {
            "code": 500116,
            "message": "Se il prodotto è scaricabile, devi fornire i campi downloadtype, urldownload e urldownloadsample"
        },
        {
            "code": 500117,
            "message": "Se almeno un articolo è un prodotto scaricabile, tutti gli articoli devono essere scaricabili"
        },
        {
            "code": 500118,
            "message": "Questo ordine non ha articoli scaricabili"
        },
        {
            "code": 500119,
            "message": "Questo dispositivo è già registrato"
        },
        {
            "code": 500120,
            "message": "Questo dispositivo non è registrato"
        },
        {
            "code": 500121,
            "message": "Questo dispositivo non appartiene a questo utente"
        },
        {
            "code": 500122,
            "message": "Prodotto scaricabile non può creare variazioni"
        },
        {
            "code": 500123,
            "message": "Prodotto scaricabile non può ricevere attributi"
        },
        {
            "code": 500124,
            "message": "Prelievo minimo consentito violato"
        },
        {
            "code": 500125,
            "message": "Solo gli Area Manager possono creare prodotti con informazioni tecniche"
        },
        {
            "code": 500126,
            "message": "Id informazione tecnica non trovato"
        },
        {
            "code": 500127,
            "message": "Campi weight, height, width o length non trovati"
        },
        {
            "code": 500128,
            "message": "Questo prodotto è già stato aggiunto ai preferiti da questo utente"
        },
        {
            "code": 500129,
            "message": "Questo prodotto non è stato aggiunto ai preferiti da questo utente"
        },
        {
            "code": 500130,
            "message": "Prelievo non trovato"
        },
        {
            "code": 500131,
            "message": "Questo prelievo è già stato elaborato"
        },
        {
            "code": 500132,
            "message": "Questo utente è già bloccato"
        },
        {
            "code": 500133,
            "message": "Questo utente è già sbloccato"
        },
        {
            "code": 500134,
            "message": "Ricerca non trovata"
        },
        {
            "code": 500135,
            "message": "Questa ricerca è già stata confermata"
        },
        {
            "code": 500136,
            "message": "Esiste già un Brand con questa descrizione"
        },
        {
            "code": 500137,
            "message": "Questo tipo è già associato a questa sottocategoria"
        },
        {
            "code": 500138,
            "message": "Questo marchio è già associato a questa sottocategoria"
        },
        {
            "code": 500139,
            "message": "Configurazione marketplace non trovata"
        },
        {
            "code": 500140,
            "message": "Questo prodotto non può essere spedito. Contatta il venditore."
        },
        {
            "code": 500141,
            "message": "Non possiamo ancora spedire da questo paese."
        },
        {
            "code": 500142,
            "message": "Non siamo riusciti a trovare un corriere per il tuo ordine."
        },
        {
            "code": 500143,
            "message": "Questo venditore non può ancora spedire"
        },
        {
            "code": 500144,
            "message": "Questo prodotto non può essere spedito al momento"
        },
        {
            "code": 500146,
            "message": "I prodotti scaricabili non possono essere spediti"
        },
        {
            "code": 500147,
            "message": "I servizi non possono essere spediti"
        },
        {
            "code": 500148,
            "message": "Questo ordine non ha ancora un pacco assegnato. Attendi qualche minuto e riprova!"
        },
        {
            "code": 500149,
            "message": "C'è già un ritiro prenotato per questo pacco"
        },
        {
            "code": 500150,
            "message": "Solo il venditore può prenotare un ritiro"
        },
        {
            "code": 500151,
            "message": "Conversione non trovata"
        },
        {
            "code": 500152,
            "message": "Conversione scaduta"
        },
        {
            "code": 500153,
            "message": "Questa conversione non appartiene all'utente della richiesta"
        },
        {
            "code": 500154,
            "message": "Questa conversione è già stata utilizzata"
        },
        {
            "code": 500155,
            "message": "Questo utente ha già registrato l'indirizzo. Per modificarlo, contatta il supporto."
        },
        {
            "code": 500156,
            "message": "Questo ordine contiene un servizio. Tutti gli articoli devono essere servizi."
        },
        {
            "code": 500157,
            "message": "Questo ordine non è associato a un pacco."
        },
        {
            "code": 500158,
            "message": "I Partner non possono creare più di 50 prodotti pubblicati!"
        },
        {
            "code": 500159,
            "message": "I Partner non possono creare più di 50 prodotti non pubblicati!"
        },
        {
            "code": 500160,
            "message": "Hai un abbonamento trial! Non puoi richiedere prelievi!"
        },
        {
            "code": 500161,
            "message": "Solo Manager e Partner devono rinnovare l'abbonamento!"
        },
        {
            "code": 500162,
            "message": "Puoi rinnovare l'abbonamento solo da 10 giorni prima della scadenza!"
        },
        {
            "code": 500163,
            "message": "Il rinnovo non può essere pagato con questo metodo di pagamento!"
        },
        {
            "code": 500164,
            "message": "Questo metodo può pagare solo il rinnovo!"
        },
        {
            "code": 500165,
            "message": "Questo voucher non può essere usato per pagare questo piano!"
        },
        {
            "code": 500166,
            "message": "Codice di sicurezza non valido o scaduto"
        },
        {
            "code": 500167,
            "message": "L'id del piano deve essere Seller"
        },
        {
            "code": 500168,
            "message": "La percentuale di extracoin deve essere tra il 30% e il 97% per i Seller"
        },
        {
            "code": 500169,
            "message": "Un prodotto non può essere servizio e scaricabile contemporaneamente"
        },
        {
            "code": 500170,
            "message": "Stai tentando di aggiungere un servizio a un ordine con articoli non di servizio"
        },
        {
            "code": 500171,
            "message": "Domanda prodotto non trovata"
        },
        {
            "code": 500172,
            "message": "Questo utente non può rispondere a questa domanda"
        },
        {
            "code": 500173,
            "message": "Questa domanda è già stata risposta"
        },
        {
            "code": 500174,
            "message": "Non puoi chiedere informazioni sul tuo prodotto"
        },
        {
            "code": 500175,
            "message": "Notifica non trovata"
        },
        {
            "code": 500176,
            "message": "Questa notifica non appartiene all'utente della richiesta"
        },
        {
            "code": 500177,
            "message": "Le tue notifiche non possono essere inviate perché il saldo extracoin è insufficiente, ma il prodotto è registrato correttamente"
        },
        {
            "code": 500178,
            "message": "Se il tuo ordine ha almeno un articolo con spedizione gratuita, tutti devono averla"
        },
        {
            "code": 500179,
            "message": "Non puoi creare prodotti"
        },
        {
            "code": 500180,
            "message": "Non puoi passare a SilverPro"
        },
        {
            "code": 500181,
            "message": "Non puoi passare a GeoGold"
        },
        {
            "code": 500182,
            "message": "Non puoi passare a StartSeller"
        },
        {
            "code": 500183,
            "message": "Share Content non trovato"
        },
        {
            "code": 500184,
            "message": "Questo prodotto è già stato condiviso da questo utente"
        },
        {
            "code": 500185,
            "message": "Portafoglio Extrabonus non trovato"
        },
        {
            "code": 500186,
            "message": "Questo ordine non può essere ritirato all'indirizzo del venditore"
        },
        {
            "code": 500187,
            "message": "publicKey non trovata"
        },
        {
            "code": 500188,
            "message": "transactionidCrypto non trovato"
        },
        {
            "code": 500189,
            "message": "Errore di pagamento. Non siamo riusciti a confermare la transazione del tuo portafoglio crypto."
        },
        {
            "code": 500190,
            "message": "Se il prodotto è importato, devi fornire il campo OriginProductImported"
        },
        {
            "code": 500191,
            "message": "Se il prodotto è importato da Banggood, devi fornire il campo ProductIdBanggood"
        },
        {
            "code": 500192,
            "message": "Questo prodotto non è assegnato a questo attributo"
        },
        {
            "code": 500193,
            "message": "Questo attributo è assegnato in almeno una variante! Elimina prima le varianti!"
        },
        {
            "code": 500194,
            "message": "Modifica il prodotto e imposta la percentuale di cashback prima di pubblicare"
        },
        {
            "code": 500195,
            "message": "La percentuale di cashback deve essere tra l'1% e il 5% per i Customers"
        },
        {
            "code": 500196,
            "message": "Negozio non trovato"
        },
        {
            "code": 500197,
            "message": "Questo negozio non appartiene a questo utente"
        },
        {
            "code": 500198,
            "message": "Slug non disponibile"
        },
        {
            "code": 500199,
            "message": "Questo ordine è già PAGATO"
        },
        {
            "code": 500200,
            "message": "Questo pagamento non ha un bonifico bancario associato"
        },
        {
            "code": 500201,
            "message": "PaymentPlan non trovato"
        },
        {
            "code": 500202,
            "message": "Questo PaymentPlan è già pagato"
        },
        {
            "code": 500203,
            "message": "Prodotto non disponibile per la vendita"
        },
        {
            "code": 500204,
            "message": "Solo il profilo negozio può usare questo tipo di pagamento"
        },
        {
            "code": 500205,
            "message": "Pagamento non trovato"
        },
        {
            "code": 500206,
            "message": "Fallimento nell'autenticazione"
        },
        {
            "code": 500207,
            "message": "La somma dei valori dei due portafogli (principale + extracredit) deve essere uguale all'importo da pagare"
        },
        {
            "code": 500208,
            "message": "Il tuo profilo non consente questa operazione"
        },
        {
            "code": 500209,
            "message": "Sezione marketplace non trovata"
        },
        {
            "code": 500210,
            "message": "Negozio non ancora configurato! Configuralo prima."
        },
        {
            "code": 500211,
            "message": "Questo profilo non può indicare questa registrazione"
        },
        {
            "code": 500212,
            "message": "Fringe Benefit non trovato"
        },
        {
            "code": 500213,
            "message": "Fringe Benefit Order non trovato"
        },
        {
            "code": 500214,
            "message": "Fringe Benefit Order è già pagato"
        },
        {
            "code": 500215,
            "message": "Questo Fringe Benefit Order non appartiene a questo utente"
        },
        {
            "code": 500216,
            "message": "Importo insufficiente di questo beneficio"
        },
        {
            "code": 500217,
            "message": "La somma di Extracoin + Wallet + Paypal deve essere il totale dell'ordine"
        },
        {
            "code": 500218,
            "message": "Nessun pagamento assegnato a questo ordine"
        },
        {
            "code": 500219,
            "message": "Voucher Fringe Benefit non trovato"
        },
        {
            "code": 500220,
            "message": "Voucher Fringe Benefit è già stato utilizzato"
        },
        {
            "code": 500221,
            "message": "Questo voucher non può essere usato in questo venditore"
        },
        {
            "code": 500222,
            "message": "Istanza Whatsapp non trovata"
        },
        {
            "code": 500223,
            "message": "Indirizzo non trovato"
        },
        {
            "code": 500224,
            "message": "Questo indirizzo non appartiene a questo utente"
        },
        {
            "code": 500225,
            "message": "Questo ordine non è per il ritiro all'indirizzo del negozio"
        },
        {
            "code": 500226,
            "message": "Questo ordine è già per il ritiro all'indirizzo del negozio"
        },
        {
            "code": 500227,
            "message": "Documento non trovato"
        },
        {
            "code": 500228,
            "message": "Non siamo riusciti a confermare la tua email"
        },
        {
            "code": 500230,
            "message": "Nessuna richiesta di cambio password trovata"
        },
        {
            "code": 500231,
            "message": "Questa richiesta di cambio password è già stata utilizzata"
        },
        {
            "code": 500232,
            "message": "La personalizzazione del tema è consentita solo ai Manager"
        },
        {
            "code": 500233,
            "message": "Tema non trovato"
        },
        {
            "code": 500234,
            "message": "Questo utente non può personalizzare il tema"
        },
        {
            "code": 500235,
            "message": "Formato numero di telefono non valido. Usa il formato internazionale con prefisso (es.: +393471234567)."
        },
        {
            "code": 500236,
            "message": "Conto bancario non trovato o non appartiene a questo utente"
        },
        {
            "code": 500237,
            "message": "Nome banca, IBAN e intestatario del conto sono obbligatori"
        },
        {
            "code": 500238,
            "message": "Numero Whatsapp non trovato, non appartiene a questo utente o già confermato"
        },
        {
            "code": 500239,
            "message": "Questo utente ha già un numero WhatsApp associato! Rimuovilo per aggiungerne un altro."
        },
        {
            "code": 500240,
            "message": "Solo i manager possono creare una subnet"
        },
        {
            "code": 500241,
            "message": "Questo utente ha già una subnet"
        },
        {
            "code": 500242,
            "message": "Codice ATECO non trovato"
        },
        {
            "code": 500243,
            "message": "Utente non autorizzato a rimuovere questo codice ATECO"
        },
        {
            "code": 500244,
            "message": "L'utente non appartiene a nessuna subnet"
        },
        {
            "code": 500245,
            "message": "L'utente appartiene già a una subnet"
        },
        {
            "code": 500246,
            "message": "Completa la registrazione con il tuo indirizzo o autorizza la condivisione della geolocalizzazione."
        },
        {
            "code": 500247,
            "message": "Questo utente ha già compilato il modulo profilo"
        },
        {
            "code": 500248,
            "message": "I Customers non possono creare più di 5 prodotti pubblicati"
        },
        {
            "code": 500249,
            "message": "I Customers non possono creare più di 5 prodotti non pubblicati"
        },
        {
            "code": 500250,
            "message": "Subnet non trovata"
        },
        {
            "code": 500251,
            "message": "Questo utente non appartiene a questa subnet"
        },
        {
            "code": 500252,
            "message": "Il negozio non è approvato per vendite in negozio fisico. Invia prima la prova del negozio fisico."
        },
        {
            "code": 500253,
            "message": "Nessuna prova di negozio fisico trovata per questo utente"
        },
        {
            "code": 500254,
            "message": "Il campo reason è obbligatorio per il rifiuto"
        },
        {
            "code": 500255,
            "message": "Questo negozio è già StartSeller"
        },
        {
            "code": 500256,
            "message": "Il campo physicalStoreName è obbligatorio"
        },
        {
            "code": 500257,
            "message": "Il campo proofPhotoUrl è obbligatorio"
        },
        {
            "code": 500258,
            "message": "Il campo physicalAddress è obbligatorio"
        },
        {
            "code": 500259,
            "message": "Il campo physicalCity è obbligatorio"
        },
        {
            "code": 500260,
            "message": "Il negozio deve accettare i termini della convenzione per procedere"
        },
        {
            "code": 500261,
            "message": "Nessuna convenzione firmata trovata per questo negozio"
        },
        {
            "code": 500262,
            "message": "Il campo legalRepresentativeName è obbligatorio"
        },
        {
            "code": 500263,
            "message": "Il campo taxId (Partita IVA / C.F.) è obbligatorio"
        },
        {
            "code": 500264,
            "message": "Il campo commercialName (Insegna) è obbligatorio"
        },
        {
            "code": 500265,
            "message": "Il campo address è obbligatorio"
        },
        {
            "code": 500266,
            "message": "Il campo city è obbligatorio"
        },
        {
            "code": 500267,
            "message": "Il campo merchantCategory è obbligatorio"
        },
        {
            "code": 500268,
            "message": "Il negozio deve firmare la convenzione Extraconomy prima di inviare la prova del negozio fisico"
        },
        {
            "code": 500300,
            "message": "Autenticazione all'API Aruba non riuscita (signin)"
        },
        {
            "code": 500301,
            "message": "Rinnovo del token dell'API Aruba non riuscito (refresh)"
        },
        {
            "code": 500310,
            "message": "Non è stato possibile determinare la provincia fiscale"
        },
        {
            "code": 500311,
            "message": "Il documento dell'utente è vuoto"
        },
        {
            "code": 500312,
            "message": "Il documento dell'utente non corrisponde né a un Codice Fiscale né a una Partita IVA"
        },
        {
            "code": 500313,
            "message": "Questo tipo di utente non ha dati fiscali o di indirizzo"
        },
        {
            "code": 500314,
            "message": "Dati anagrafici incompleti per l'emissione della fattura"
        },
        {
            "code": 500315,
            "message": "La configurazione del cedente (Extraconomy) è incompleta"
        },
        {
            "code": 500320,
            "message": "Questo tipo di utente non ha dati fiscali"
        },
        {
            "code": 500321,
            "message": "È necessario indicare se è Persona Fisica o Giuridica"
        },
        {
            "code": 500322,
            "message": "Tipo di persona non valido"
        },
        {
            "code": 500323,
            "message": "Questo tipo di utente non può essere modificato nel tipo selezionato"
        },
        {
            "code": 500324,
            "message": "Il nome fiscale è obbligatorio per la Persona Giuridica"
        },
        {
            "code": 500325,
            "message": "Nome e cognome sono obbligatori per la Persona Fisica"
        },
        {
            "code": 500326,
            "message": "Il documento (CF/P.IVA) è obbligatorio"
        },
        {
            "code": 500327,
            "message": "L'indirizzo è obbligatorio"
        },
        {
            "code": 500328,
            "message": "Il numero è obbligatorio"
        },
        {
            "code": 500329,
            "message": "Il CAP è obbligatorio"
        },
        {
            "code": 500330,
            "message": "La città è obbligatoria"
        },
        {
            "code": 500331,
            "message": "Il paese è obbligatorio"
        },
        {
            "code": 500332,
            "message": "Partita IVA o codice fiscale non valido"
        },
        {
            "code": 500400,
            "message": "Fatturazione automatica bloccata"
        },
        {
            "code": 500410,
            "message": "Importo di prelievo non valido (nullo o ≤ 0)"
        },
        {
            "code": 500411,
            "message": "Wallet di token non trovato per l'utente"
        },
        {
            "code": 500412,
            "message": "Saldo insufficiente per il prelievo richiesto"
        },
        {
            "code": 500413,
            "message": "Richiesta di prelievo non trovata (durante l'elaborazione)"
        },
        {
            "code": 500414,
            "message": "La richiesta era già stata elaborata in precedenza"
        },
        {
            "code": 500415,
            "message": "Inserisci l'indirizzo EXC per il prelievo"
        },
        {
            "code": 500416,
            "message": "Inserisci il codice di verifica inviato via e-mail"
        }
    ]
}

export default message_IT;
